import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import jwt_decode from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class EncryptService {

  secretKey: string = 'ENCRYPT_SECRET_KEY';
  constructor() { }

  mencrypt = (req: any) => {
    const encryptedResponse = CryptoJS.AES.encrypt(
      JSON.stringify(req),
      this.secretKey
    ).toString();
  
    return encryptedResponse;
  };
  
  mdecrypt = (res: any) => {
    const decryptedResponse = JSON.parse(
      CryptoJS.AES.decrypt(
        res,
        this.secretKey
      ).toString(CryptoJS.enc.Utf8)
    );
  
    return decryptedResponse;
  };

  getDecodedAccessToken(token: string): any {
    try {
      return jwt_decode(token);
    } catch(Error) {
      return null;
    }
  }
}
